export const isProduction = () => {
	return window._es_env.app.mode !== "development";
};
